import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.RentForecast.UtilityAllowanceTable.Title',
    defaultMessage:
      'Utility Allowances for {currentRentForecastName} - {currentRentForecastYear}',
  },
  utilityAllowanceTableElectricColumnTooltip: {
    id: 'App.RentForecast.UtilityAllowanceTable.ElectricColumnTooltip',
    defaultMessage:
      'All allowances start in Electric. Allocating to specific utilities reduces the Electric amount accordingly.', // eslint-disable-line max-len
  },
  utilityAllowanceTableTotalCurrentUtilityAllowanceTooltip: {
    id: 'App.RentForecast.UtilityAllowanceTable.TotalCurrentUtilityAllowanceTooltip',
    defaultMessage:
      'This is the total sum of all current utility allowances for each floor plan, pulled from the Forecast Rents screen.', // eslint-disable-line max-len
  },
  utilityAllowanceTableTotalProposedUtilityAllowanceTooltip: {
    id: 'App.RentForecast.UtilityAllowanceTable.TotalProposedUtilityAllowanceTooltip',
    defaultMessage:
      'This is the total sum of all proposed utility allowances for each floor plan, pulled from the Forecast Rents screen.', // eslint-disable-line max-len
  },
  utilitAllowanceTableColumnTitleElectric: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleElectric',
    defaultMessage: 'Electric',
  },
  utilitAllowanceTableColumnTitleGas: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleGas',
    defaultMessage: 'Gas',
  },
  utilitAllowanceTableColumnTitleWater: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleWater',
    defaultMessage: 'Water',
  },
  utilitAllowanceTableColumnTitleSewer: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleSewer',
    defaultMessage: 'Sewer',
  },
  utilitAllowanceTableColumnTitleTrash: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleTrash',
    defaultMessage: 'Trash',
  },
  utilitAllowanceTableColumnTitleOther: {
    id: 'App.RentForecast.UtilityAllowanceTable.ColumnTitleOther',
    defaultMessage: 'Other',
  },
  utilityAllowanceTableTotalCurrentUtilityAllowance: {
    id: 'App.RentForecast.UtilityAllowanceTable.TotalCurrentUtilityAllowance',
    defaultMessage: 'Total Current Utility Allowance',
  },
  utilityAllowanceTableTotalProposedUtilityAllowance: {
    id: 'App.RentForecast.UtilityAllowanceTable.TotalProposedUtilityAllowance',
    defaultMessage: 'Total Proposed Utility Allowance',
  },
  utilityAllowanceSaved: {
    id: 'App.RentForecast.UtilityAllowanceTable.UtilityAllowanceSaved',
    defaultMessage: 'Utility Allowances Saved Successfully!',
  },
  utilityAllowanceTableElectricError: {
    id: 'App.RentForecast.UtilityAllowanceTable.ElectricError',
    defaultMessage:
      "The sum of all utilities exceeds the total for the floor plan, resulting in negative electric charges. Adjust the utility amounts to stay within the floor plan's total allowance.", // eslint-disable-line max-len
  },
  utilityAllowanceTableProposedChanged: {
    id: 'App.RentForecast.UtilityAllowanceTable.ProposedChange',
    defaultMessage: 'Proposed Change',
  },
});
export default messages;
